var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('floating-modal',{attrs:{"show":_vm.modal.show,"type":_vm.modal.type,"title":_vm.modal.title,"message":_vm.modal.message,"confirm-text":_vm.modal.confirmText,"show-cancel":_vm.modal.showCancel},on:{"confirm":_vm.handleModalConfirm,"cancel":_vm.handleModalCancel,"close":_vm.handleModalClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }